<template>
  <div>
    <AccountingClients v-if="$getConstRole('ROLE_ACCOUNTING') == role"></AccountingClients>
    <AgentClients v-if="$getConstRole('ROLE_AGENT') == role"></AgentClients>
    <AdminClients v-if="$getConstRole('ROLE_ADMIN') == role"></AdminClients>
    <OperationsClients v-if="$getConstRole('ROLE_OPERATIONS') == role"></OperationsClients>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AgentClients from '@/views/agent/client/Clients.vue'
import AdminClients from '@/views/admin/client/Clients.vue'
import AccountingClients from '@/views/accountant/client/Clients.vue'
import OperationsClients from '@/views/operations/client/Clients.vue'

export default {
  name: 'Clients',
  data: () => ({
    role: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  mounted () {
    this.role = this.getCurrentUser.role
  },
  methods: {
  },
  components: {
    AgentClients,
    AdminClients,
    AccountingClients,
    OperationsClients
  },
};
</script>
